module.exports = __webpack_public_path__ + "static/img/safe@2x.52988433.png";